import '../css/main.scss'
import 'bootstrap'
import { DOM, IOO, pipe, RA, RR, s, v } from '@packages/prelude'
import { Swiper } from 'swiper'
import { Navigation } from 'swiper/modules'
import { SwiperOptions } from 'swiper/types'

const makeSwiper = (selector: string, options: SwiperOptions) =>
  pipe(
    IOO.of({ document }),
    IOO.chain(({ document }) => pipe(document, DOM.querySelectorAll(`[id^="${selector}-"]`))),
    IOO.chainFirstIOK(
      elements => () =>
        pipe(
          elements,
          RA.map(element => new Swiper(element as HTMLElement, options))
        )
    )
  )()

const Swipers: Record<string, SwiperOptions> = {
  flexslider: {
    modules: [Navigation],
    slidesPerView: 1,
    speed: 750,
    loop: true,
    spaceBetween: 24,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next'
    }
  }
}

pipe(
  Swipers,
  RR.foldMapWithIndex(s.Ord)(v.Monoid)((selector, options) => makeSwiper(selector, options))
)
